// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3v1ax","right":"styles_right__1bHGC"};